import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import ReactSlider from 'react-slider';
import tweenState from 'react-tween-state';
import classNames from 'classnames';
import range from 'lodash/range';

const TWEEN_DEFAULT_SPEED = 200;
const TWEEN_START_SPEED = 400;

var SliderField = createReactClass({
    displayName: 'SliderField',
    mixins: [tweenState.Mixin],

    propTypes: {
        onChange: PropTypes.func.isRequired,
        disableInitialAnimation: PropTypes.bool,
        initialValue: PropTypes.number,
        steps: PropTypes.number,
        minLabel: PropTypes.string,
        maxLabel: PropTypes.string,
        color: PropTypes.string,
    },

    getDefaultProps: function() {
        return {
            steps: 7,
            initialValue: 0,
        };
    },

    componentDidMount() {
        // Set 0 second timeout to allow react-slider enough time to determine viewport size.
        this.viewportTimeoutId = setTimeout(() => {
            this.setState({ initialised: true });
            this.tweenToClosest(this.translateValue(this.props.initialValue), TWEEN_START_SPEED);
        }, 0);
    },

    componentWillUnmount() {
        // Cleanup timeouts on unmount to avoid async setState on unmounted components
        clearTimeout(this.viewportTimeoutId);
    },

    getInitialState: function() {
        return {
            active: false,
            value: this.translateValue(0),
            initialised: false,
        };
    },

    onChange: function(value) {
        this.setState({
            value: value,
            active: true,
        });
    },

    getStepSize: function() {
        return 100 / (this.props.steps - 1);
    },

    // Translate an negative/positive scale value into 100 point scale value by
    // default. Allow custom translate functions if required.
    translateValue: function(value) {
        const { customTranslate } = this.props;
        const stepSize = this.getStepSize();
        const translatedValue = value * stepSize;

        if (customTranslate) {
            return customTranslate(translatedValue);
        } else {
            return translatedValue + 50;
        }
    },

    // Round a value to the closest step.
    roundValue: function(value) {
        let stepSize = this.getStepSize();
        if (value % stepSize >= stepSize / 2) {
            return Math.ceil(value / stepSize) * stepSize;
        } else {
            return Math.floor(value / stepSize) * stepSize;
        }
    },

    tweenToMarker: function(idx) {
        let value = this.getStepSize() * idx;
        this.tweenToClosest(value);
    },

    tweenToClosest: function(value, speed) {
        this.tweenState('value', {
            easing: tweenState.easingTypes.easeInOutQuad,
            duration: speed || TWEEN_DEFAULT_SPEED,
            value: value,
            endValue: this.roundValue(value),
            onEnd: () => {
                let roundedValue = this.roundValue(value);
                let scaleValue = Math.round((roundedValue - 50) / this.getStepSize());
                this.props.onChange(scaleValue);
            },
        });
    },

    hideMarkers: function() {
        this.setState({
            active: false,
        });
    },

    showMarkers: function() {
        this.setState({
            active: true,
        });
    },

    computeInlineSliderStyles: function() {
        if (!!this.props.color) {
            return {
                color: this.props.color,
            };
        }
        return {};
    },

    render: function() {
        const sliderClasses = classNames('slider', {
            'slider--initialised': this.state.initialised,
            'slider--chameleon': !!this.props.color,
        });
        return (
            <div
                className="slider-field"
                data-testid="slider-field"
                data-active={this.state.active}
            >
                <div className="slider-field__labels">
                    <div className="slider-field__labels__label--min">{this.props.minLabel}</div>
                    <div className="slider-field__labels__label--max">{this.props.maxLabel}</div>
                </div>
                <div
                    className="slider-field__slider"
                    style={this.computeInlineSliderStyles()}
                    onMouseEnter={this.showMarkers}
                    onMouseLeave={this.hideMarkers}
                >
                    <ReactSlider
                        className={sliderClasses}
                        handleClassName="slider__handle"
                        handleActiveClassName="slider__handle--active"
                        onChange={this.onChange}
                        onAfterChange={this.tweenToClosest}
                        value={this.getTweeningValue('value')}
                    />

                    <div className="slider-field__markers">
                        {range(this.props.steps).map(item => {
                            return (
                                <span
                                    key={item}
                                    onClick={this.tweenToMarker.bind(this, item)}
                                    className="slider-field__markers__marker"
                                    data-testid="slider-field__markers__marker"
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    },
});

export default SliderField;
